/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/transfer_medium'
export default icon
